import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRectangleXmark,
  faMagnifyingGlass,
  faCircleNotch,
} from "@fortawesome/free-solid-svg-icons";
import logo from "../images/logo.png";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

import RecapResa from "./RecapResa";

export default function ConsulterResa() {
  const navigate = useNavigate();

  const [query, setQuery] = useState("");
  const [reservation, setReservation] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const isValidQuery = useMemo(() => {
    const q = (query || "").trim();
    return q.length >= 4; // adapte si tes IDs ont une longueur précise
  }, [query]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const resetSearch = () => {
    setReservation(null);
    setErrorMsg("");
  };

  const goHome = () => {
    resetSearch();
    navigate("/");
  };

  async function getReservationList(e) {
    e?.preventDefault();
    setErrorMsg("");

    const q = (query || "").trim();
    if (!q) {
      setErrorMsg("Veuillez saisir un numéro de réservation.");
      return;
    }
    if (!isValidQuery) {
      setErrorMsg("Numéro invalide. Merci de vérifier votre saisie.");
      return;
    }

    try {
      setLoading(true);

      const token = "1654551514hhgfhfb45665454";
      const url = `${process.env.REACT_APP_BAC_URL}/mail/reservation`;

      const payload = {
        reservationId: q,
        headers: "true",
      };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: "bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (!response.ok) {
        setErrorMsg(
          result?.message ||
            "Impossible de récupérer la réservation. Veuillez réessayer.",
        );
        return;
      }

      // selon ton API : result.data
      if (!result?.data) {
        setErrorMsg("Aucune réservation trouvée avec ce numéro.");
        return;
      }

      setReservation(result.data);
      setShowModal(true);
    } catch (err) {
      setErrorMsg("Erreur réseau. Veuillez réessayer dans un instant.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="resa-page">
      {/* Header */}

      <div className="resa-header">
        <div className="resa-header-center">
          <img src={logo} alt="AzurPac VTC" className="resa-logo-large" />

          <h2 className="resa-title">Consulter une réservation</h2>

          <p className="resa-subtitle">
            Entrez votre numéro de réservation pour accéder aux détails de votre
            course
          </p>
        </div>

        <button
          className="resa-close"
          onClick={goHome}
          type="button"
          aria-label="Fermer"
        >
          <FontAwesomeIcon icon={faRectangleXmark} />
        </button>
      </div>

      {/* Card recherche */}
      <div className="resa-card">
        <div className="resa-card-top">
          <h3 className="resa-card-title">Rechercher</h3>
          <p className="resa-card-help">
            Exemple : le numéro reçu dans votre email de confirmation.
          </p>
        </div>

        <Form onSubmit={getReservationList} className="resa-search">
          <div className="resa-search-input">
            <Form.Control
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="N° réservation"
              className="resa-input"
              autoComplete="off"
            />
            <button
              type="submit"
              className="resa-search-btn"
              disabled={loading}
              aria-label="Rechercher"
            >
              {loading ? (
                <FontAwesomeIcon icon={faCircleNotch} spin />
              ) : (
                <FontAwesomeIcon icon={faMagnifyingGlass} />
              )}
            </button>
          </div>

          {errorMsg && <div className="resa-error">{errorMsg}</div>}

          <div className="resa-actions">
            <Button
              type="button"
              variant="outline-secondary"
              className="resa-btn-outline"
              onClick={() => {
                setQuery("");
                resetSearch();
              }}
              disabled={loading}
            >
              Effacer
            </Button>

            <Button
              type="submit"
              className="btn-primary-gold resa-btn-gold"
              disabled={loading}
            >
              {loading ? "Recherche..." : "Afficher"}
            </Button>
          </div>
        </Form>
      </div>

      <RecapResa reservationList={reservation} />
    </div>
  );
}
